import styles from './carousel.module.css';
import { useState, useRef, useEffect } from 'react';

export default function BookCarousel({ images, start = 1 }) {
  const [currentIndex, setCurrentIndex] = useState(start);

  // Use a ref to store touchStartX across handlers
  const touchStartXRef = useRef(null);

  useEffect(() => {
    const handleTouchStart = (e) => {
      touchStartXRef.current = e.touches[0].clientX;
    };

    const handleTouchEnd = (e) => {
      if (touchStartXRef.current === null) return;
      const touchEndX = e.changedTouches[0].clientX;
      if (touchStartXRef.current > touchEndX + 50) {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
      } else if (touchStartXRef.current < touchEndX - 50) {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
      }
      touchStartXRef.current = null;
    };

    document.addEventListener('touchstart', handleTouchStart);
    document.addEventListener('touchend', handleTouchEnd);

    return () => {
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, [images.length]);

  return (
    <div className={styles.carousel}>
      <div className={styles.carouselInner} style={{ width: `${images.length * 100}%`, transform: `translateX(-${currentIndex * 100 / images.length}%)` }}>
        {images.map((image, index) => (
          <div key={image} className={styles.carouselItem} style={{
            background: `url(${image})`, width: `${100 / images.length}%`
          }}></div>
        ))}
      </div>
      <button
        className={styles.prev}
        onClick={() => setCurrentIndex((currentIndex - 1 + images.length) % images.length)}
      >
        <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g opacity="0.1">
            <path d="M48 57L27 34.4999L48 12" stroke="#262626" stroke-width="2" />
          </g>
        </svg>
      </button>
      <button
        className={styles.next}
        onClick={() => setCurrentIndex((currentIndex + 1) % images.length)}
      >
        <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g opacity="0.1">
            <path d="M24 57L45 34.4999L24 12" stroke="#262626" stroke-width="2" />
          </g>
        </svg>
      </button>
      {/*<div className={styles.indicator}>
        <div className={styles.indicators}>
          {images.map((_, index) => (
            <button
              key={index}
              className={`${styles.indicator} ${currentIndex === index ? styles.active : ''}`}
              onClick={() => setCurrentIndex(index)}
            ><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle opacity="0.25" cx="6" cy="6" r="6" fill="#262626" />
              </svg></button>
          ))}
        </div>
      </div>*/}
    </div>
  )
}